<div [ngClass]="{'ppl-mt24': source !== 'enrollment'}">
  <nz-card nz-col [nzSpan]="source !== 'enrollment' ? 20 : 24" class="ppl-p24 ppl-step-main" [nzBordered]="false">
    <form nz-form [formGroup]="servicesForm" class="ppl-p0">
      <nz-row>
        <div nz-col nzSpan="12" nz-flex>
          @if(isAttrAvailable('profLicences')){
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="24" [nzXs]="24" nzFor="profLicences"
              class="ppl-form-label">{{getAttributes('profLicences').label}}
              @if(getAttributes('profLicences').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }</nz-form-label>
            <nz-form-control class="">
              <div nz-tooltip [nzTooltipTitle]="getAttributes('profLicences')?.tooltip || ''"
                nzTooltipPlacement="topRight">
                <div [ngClass]="{'error': validationErrors['profLicences'] }">
                  <ppl-multiselect formControlName="profLicences" id="profLicences" [options]="licences" style="width:100%; margin-bottom: 16px"
                    [showClear]="true" placeholder="{{getAttributes('profLicences').placeholder}}" [optionLabel]="'lkpValueName'"
                    [optionValue]="'lkpValueCode'" [disabled]="formReadonly" [maxTagCount]="4" style="width:100%; margin-bottom: 16px">
                  </ppl-multiselect>
                </div>
              </div>
              @if (validationErrors['profLicences']) {
              <span class="pl-1 error-message">{{validationErrors['profLicences']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
          }
        </div>
        <div nz-col nzSpan="12" nz-flex>
          @if(isAttrAvailable('servicesRendered')){
          <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="24" [nzXs]="24" nzFor="servicesRendered"
              class="ppl-form-label">{{getAttributes('servicesRendered').label}}
              @if(getAttributes('servicesRendered').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }</nz-form-label>
            <nz-form-control class="ppl-form-control">
              <div [ngClass]="{'error': validationErrors['servicesRendered'] }">
                <ppl-multiselect formControlName="servicesRendered" id="servicesRendered" [options]="services" style="width:100%; margin-bottom: 16px"
                  [showClear]="true" placeholder="{{getAttributes('servicesRendered').placeholder}}" [optionLabel]="'lkpValueName'"
                  [optionValue]="'lkpValueCode'" [disabled]="formReadonly" [maxTagCount]="4" style="width:100%; margin-bottom: 16px">
                </ppl-multiselect>
              </div>
              @if (validationErrors['servicesRendered']) {
              <span class="pl-1 error-message">{{validationErrors['servicesRendered']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
          }
        </div>
      </nz-row>
      <nz-row>
        @if(isAttrAvailable('consent')){
          <nz-col [nzSm]="18" [nzXs]="24">
            <ul class="bullet-list" id="consent-rules">
              <li class="bullet-item">I understand that I am not required to appoint a Designated Representative (DR).</li>
              <li class="bullet-item">
                My DR can help me with my <span aria-label="C D PAP">CDPAP</span> duties, including training, supervising and directing my Personal Assistants (PAs).
              </li>
              <li class="bullet-item">My DR will be able to speak to PPL about me and my PAs.</li>
              <li class="bullet-item">My DR must be at least 18 years of age.</li>
              <li class="bullet-item">My DR cannot also be my PA.</li>
              <li class="bullet-item">My DR cannot be an employee of PPL, my MCO, or my LDSS Office.</li>
              <li class="bullet-item">I can remove my DR at any time by clicking the “Remove” button on the Association page.</li>
            </ul>

            <nz-form-item class="ppl-form-item">
              <nz-form-control class="ppl-form-control">

                <input
                  type="checkbox"
                  class="checkbox"
                  id="consent"
                  formControlName="consent"
                  aria-labelledby="consent-label consent-rules"
                  [attr.aria-required]="true"
                  [attr.aria-invalid]="(servicesForm.get('consent')?.invalid && (servicesForm.get('consent')?.touched || servicesForm.get('consent')?.dirty)) ? 'true' : null"
                  [attr.aria-describedby]="(servicesForm.get('consent')?.invalid && (servicesForm.get('consent')?.touched || servicesForm.get('consent')?.dirty)) ? 'consent-error' : null"
                />

                <span id="consent-label" style="margin-left: 8px; font-weight: 600;">
                  I have read and understand the above rules.
                </span>

                <p>
                  <span
                    *ngIf="validationErrors['consent']"
                    id="consent-error"
                    role="alert"
                    class="pl-1 error-message"
                  >
                    {{validationErrors['consent']}}
                  </span>
                </p>

              </nz-form-control>
            </nz-form-item>
          </nz-col>
        }
      </nz-row>



      <!-- @if(isAttrAvailable('filesUploaded')){
        <nz-form-item class="ppl-form-item pt-2">
          <nz-form-label [nzSm]="9">
          </nz-form-label>
          <nz-form-control class="ppl-form-control">
            <p style="font-size:0.929rem;">Please upload supporting documents</p>
            <ppl-upload (filesUploaded)="filesUploaded($event)" [fileList]="fileList"
            [docTypeList] = "licences" [flow]="'provider'" [leadId]="''" [showFileList]="true"></ppl-upload>
          </nz-form-control>
        </nz-form-item>
        } -->

    </form>
  </nz-card>
</div>